// @generated by protoc-gen-es v2.2.0
// @generated from file hmm/incubator/creatives_service.proto (package hmm.incubator, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv1";
import { file_hmm_incubator_creatives } from "./creatives_pb";
import { file_hmm_incubator_extensions } from "./extensions_pb";
import { file_hmm_incubator_properties } from "./properties_pb";
import { file_hmm_job_job } from "../job/job_pb";

/**
 * Describes the file hmm/incubator/creatives_service.proto.
 */
export const file_hmm_incubator_creatives_service = /*@__PURE__*/
  fileDesc("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", [file_hmm_incubator_creatives, file_hmm_incubator_extensions, file_hmm_incubator_properties, file_hmm_job_job]);

/**
 * Describes the message hmm.incubator.ListCreativesRequest.
 * Use `create(ListCreativesRequestSchema)` to create a new message.
 */
export const ListCreativesRequestSchema = /*@__PURE__*/
  messageDesc(file_hmm_incubator_creatives_service, 0);

/**
 * Describes the message hmm.incubator.ListCreativesResponse.
 * Use `create(ListCreativesResponseSchema)` to create a new message.
 */
export const ListCreativesResponseSchema = /*@__PURE__*/
  messageDesc(file_hmm_incubator_creatives_service, 1);

/**
 * Describes the message hmm.incubator.CreateCreativeRequest.
 * Use `create(CreateCreativeRequestSchema)` to create a new message.
 */
export const CreateCreativeRequestSchema = /*@__PURE__*/
  messageDesc(file_hmm_incubator_creatives_service, 2);

/**
 * Describes the message hmm.incubator.CreateCreativeResponse.
 * Use `create(CreateCreativeResponseSchema)` to create a new message.
 */
export const CreateCreativeResponseSchema = /*@__PURE__*/
  messageDesc(file_hmm_incubator_creatives_service, 3);

/**
 * Describes the message hmm.incubator.GetCreativeRequest.
 * Use `create(GetCreativeRequestSchema)` to create a new message.
 */
export const GetCreativeRequestSchema = /*@__PURE__*/
  messageDesc(file_hmm_incubator_creatives_service, 4);

/**
 * Describes the message hmm.incubator.GetCreativeResponse.
 * Use `create(GetCreativeResponseSchema)` to create a new message.
 */
export const GetCreativeResponseSchema = /*@__PURE__*/
  messageDesc(file_hmm_incubator_creatives_service, 5);

/**
 * Describes the message hmm.incubator.UpdateCreativeRequest.
 * Use `create(UpdateCreativeRequestSchema)` to create a new message.
 */
export const UpdateCreativeRequestSchema = /*@__PURE__*/
  messageDesc(file_hmm_incubator_creatives_service, 6);

/**
 * Describes the message hmm.incubator.UpdateCreativeResponse.
 * Use `create(UpdateCreativeResponseSchema)` to create a new message.
 */
export const UpdateCreativeResponseSchema = /*@__PURE__*/
  messageDesc(file_hmm_incubator_creatives_service, 7);

/**
 * Describes the message hmm.incubator.DeleteCreativeRequest.
 * Use `create(DeleteCreativeRequestSchema)` to create a new message.
 */
export const DeleteCreativeRequestSchema = /*@__PURE__*/
  messageDesc(file_hmm_incubator_creatives_service, 8);

/**
 * Describes the message hmm.incubator.DeleteCreativeResponse.
 * Use `create(DeleteCreativeResponseSchema)` to create a new message.
 */
export const DeleteCreativeResponseSchema = /*@__PURE__*/
  messageDesc(file_hmm_incubator_creatives_service, 9);

/**
 * Describes the message hmm.incubator.CloneCreativesRequest.
 * Use `create(CloneCreativesRequestSchema)` to create a new message.
 */
export const CloneCreativesRequestSchema = /*@__PURE__*/
  messageDesc(file_hmm_incubator_creatives_service, 10);

/**
 * Describes the message hmm.incubator.CloneCreativesResponse.
 * Use `create(CloneCreativesResponseSchema)` to create a new message.
 */
export const CloneCreativesResponseSchema = /*@__PURE__*/
  messageDesc(file_hmm_incubator_creatives_service, 11);

/**
 * Describes the message hmm.incubator.ListRequireAttributesRequest.
 * Use `create(ListRequireAttributesRequestSchema)` to create a new message.
 */
export const ListRequireAttributesRequestSchema = /*@__PURE__*/
  messageDesc(file_hmm_incubator_creatives_service, 12);

/**
 * Describes the message hmm.incubator.ScrapeCreativeRequest.
 * Use `create(ScrapeCreativeRequestSchema)` to create a new message.
 */
export const ScrapeCreativeRequestSchema = /*@__PURE__*/
  messageDesc(file_hmm_incubator_creatives_service, 13);

/**
 * Describes the message hmm.incubator.ScrapeCreativeResponse.
 * Use `create(ScrapeCreativeResponseSchema)` to create a new message.
 */
export const ScrapeCreativeResponseSchema = /*@__PURE__*/
  messageDesc(file_hmm_incubator_creatives_service, 14);

/**
 * Describes the message hmm.incubator.RecordCreativeRequest.
 * Use `create(RecordCreativeRequestSchema)` to create a new message.
 */
export const RecordCreativeRequestSchema = /*@__PURE__*/
  messageDesc(file_hmm_incubator_creatives_service, 15);

/**
 * Describes the message hmm.incubator.RecordCreativeResponse.
 * Use `create(RecordCreativeResponseSchema)` to create a new message.
 */
export const RecordCreativeResponseSchema = /*@__PURE__*/
  messageDesc(file_hmm_incubator_creatives_service, 16);

/**
 * Creatives service.
 *
 * @generated from service hmm.incubator.CreativesService
 */
export const CreativesService = /*@__PURE__*/
  serviceDesc(file_hmm_incubator_creatives_service, 0);

